import './style.css'
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { BasisTextureLoader } from 'three/examples/jsm/loaders/BasisTextureLoader.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import * as dat from 'dat.gui'
import { MathUtils } from 'three';


// LOAD SCREEN //////////////////////////////////////////////////////////////////////////
const startBackground = document.getElementById('StartBackground');
startBackground.style.display = 'none';

const StartCC = document.getElementById('StartCC');
StartCC.style.display = 'none';

//HTML video player /////////////////////////////////////////////////////////////////////
let playImages = ['/assets/images/play_button1.png', '/assets/images/play_button2.png', '/assets/images/play_button3.png', '/assets/images/play_button4.png', '/assets/images/play_button5.png', '/assets/images/play_button6.png', '/assets/images/play_button7.png', '/assets/images/play_button8.png', '/assets/images/play_buttontijdlijn.png', '/assets/images/play_buttonco2-neutraal.png'];

const videoContainer = document.getElementById('container')
const videoPlayer = document.getElementById('myVideo')
let isMuted = false;
let isPaused = true;

let vidheight;
const progressBar = document.getElementById('progress-bar');
const background = document.getElementById('background');

videoContainer.style.display = 'none';

const playButton = document.getElementById('playButton');
const pauseButton = document.getElementById('pauseButton');

//if (window.orientation !== 'undefined') {
//        playButton.style.margin = "-30px 0 0 -70px"
//        playButton.style.backgroundSize = "140px 60px"
//        playButton.style.height = "60px"
//        playButton.style.width = "140px"
//}


playButton.addEventListener('click', function () {
    if (isPaused) {
        vidheight = videoPlayer.offsetWidth;
        console.log(vidheight);
        progressBar.style.display = 'block';
        progressBar.style.top = "50%";
        progressBar.style.marginTop = ((vidheight / (16 / 9)) / 2)+ "px";
        
        pauseButton.style.display = 'block';
        playButton.style.display = 'none';
        videoPlayer.play();
        isPaused = false;
    }
});


pauseButton.addEventListener('click', function () {
    if (!isPaused) {
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
        videoPlayer.pause();
        isPaused = true;
    }
});

const exitButton = document.getElementById('exitButton');
exitButton.addEventListener('click', function () {

    videoPlayer.pause();
    videoContainer.style.display = 'none';
    progressBar.style.display = 'none';
    setTimeout(function () { selectedHotspot = null; }, 5);
    

});

const muteButton = document.getElementById('muteButton');
muteButton.addEventListener('click', function () {
    isMuted = !isMuted;
    if (isMuted) {
        muteButton.style.background = 'url(assets/images/video_tab2.png)';
        muteButton.style.backgroundSize = "70px 188px";
    } else {
        muteButton.style.background = 'url(assets/images/video_tab1.png)';
        muteButton.style.backgroundSize = "70px 188px";
    }
    videoPlayer.muted = isMuted;

});

function updateProgressBar() {
    // Work out how much of the media has played via the duration and currentTime parameters
    var percentage = Math.floor((100 / videoPlayer.duration) * videoPlayer.currentTime);
    // Update the progress bar's value
    progressBar.value = percentage;
    // Update the progress bar's text (for browsers that don't support the progress element)
    progressBar.innerHTML = percentage + '% played';
}

videoPlayer.addEventListener('timeupdate', updateProgressBar, false);
progressBar.addEventListener("click", seek);

function seek(e) {
    var percent = e.offsetX / this.offsetWidth;
    videoPlayer.currentTime = percent * videoPlayer.duration;
    e.target.value = Math.floor(percent / 100);
    e.target.innerHTML = progressBar.value + '% played';
}

//THREE JS /////////////////////////////////////////////////////////////////////////

// Debug
//const gui = new dat.GUI()

let size = [1920, 1080]
let ratio = size[0] / size[1]

// Canvas
let canvas

const hotspotGroup = new THREE.Group();
let clouds = [];
let camera, scene, renderer
let video, videoTexture, texture, videoMaterial
let cube, plane, drivingCar, carpos
let hotspotGeo, planeGeometry

//Hotspot lists
let hotspotOffests = [new THREE.Vector3(-1.2, -0.2, 3.3), new THREE.Vector3(1, 0, 2), new THREE.Vector3(-0.9, 0.1, 1.2), new THREE.Vector3(-2.4, 0.1, 1.4), new THREE.Vector3(-0.3, 0.1, 1.8), new THREE.Vector3(2, 0.1, -0.3), new THREE.Vector3(-1.65, 0.1, 1.2), new THREE.Vector3(1, 0.5, 1), new THREE.Vector3(-3.3, -0.5, 3), new THREE.Vector3(3.2, 0.5, 1.5)]
let hotspotImages = ['/assets/images/icon_1.png', '/assets/images/icon_2.png', '/assets/images/icon_3.png', '/assets/images/icon_4.png', '/assets/images/icon_5.png', '/assets/images/icon_6.png', '/assets/images/icon_7.png', '/assets/images/icon_8.png', '/assets/images/icon_timeline.png', '/assets/images/icon_graph.png']

//VIDEO CONTENT
let videoContentID = ['video1', 'video2', 'video3', 'video4', 'video5', 'video6', 'video7', 'video8'];

let videoContentSource = ['welcome.mp4', '1.Waterbehandelkamer.mp4', '2.Vernieuwd dak 2016_1.mp4', '3.Blaashal_1.mp4', '4.Siroopkamer_1.mp4', '5.ASRS.mp4', '100RPET.mp4', '6.Ecocombi.mp4', 'CCtijdlijn.mp4', 'CO2neutraaltijdlijn.mp4'];

//interaction
let mouse, raycaster, selectedHotspot = null

// Canvas
canvas = document.querySelector('canvas.webgl')

// Scene
scene = new THREE.Scene()
scene.background = new THREE.Color(0x75C4FF);

//Textures
texture = THREE.ImageUtils.loadTexture('/assets/images/icon_EMPTY.png');

// Materials

//object geometry
hotspotGeo = new THREE.PlaneGeometry(0.432, 0.576);


// Mesh Hotspot
for (var i = 0; i < hotspotOffests.length; i++) {
    let hotspot;
    let hotspotTexture = THREE.ImageUtils.loadTexture(hotspotImages[i]);
    let hotspotMat = new THREE.MeshBasicMaterial({ map: hotspotTexture });
    hotspotMat.transparent = true;
    hotspot = new THREE.Mesh(hotspotGeo, hotspotMat);
    hotspot.position.copy(hotspotOffests[i]);
    //alert(hotspotOffests[i].x);
    hotspotGroup.add(hotspot)
}
scene.add(hotspotGroup);

//animations
let mixer;
let lastframe;

// Lights
const hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);
hemiLight.color.setHSL(0.6, 1, 0.7);
hemiLight.groundColor.setHSL(0.05, 1, 0.75);
hemiLight.position.set(0, 10, 0);
scene.add(hemiLight);

const dirLight = new THREE.DirectionalLight(0xffffff, 1);
dirLight.color.setHSL(0.1, 1, 0.95);
dirLight.position.set(- 1, 1.75, 1);
dirLight.position.multiplyScalar(30);
scene.add(dirLight);

//MODEL
const loader = new GLTFLoader();
loader.load('/assets/cola_layout_411.glb', function (gltf) {

    gltf.scene.traverse(function (child) {
        console.log(child.name)
        if (child.name === "drivingCar") {
            drivingCar = child;
        }
    });

    gltf.scene.scale.set(0.01, 0.01, 0.01);
    gltf.scene.position.set(0, -1, -0.9);

    mixer = new THREE.AnimationMixer(gltf.scene);
    var action = mixer.clipAction(gltf.animations[0]);
    action.play();

    scene.add(gltf.scene);
   
});

loader.load('/assets/clouds.glb', function (gltf) {

    gltf.scene.traverse(function (child) {
        
        if (child instanceof THREE.Object3D) {
            console.log(child.name);
            clouds.push(child.name);
            let cloudsMat = new THREE.MeshLambertMaterial();
            cloudsMat.transparent = true;
            child.material = cloudsMat;
        }
        
    });
    gltf.scene.scale.set(1.5, 1.5, 1.5);
    gltf.scene.position.set(0, 1.5, -0);

    scene.add(gltf.scene);

});

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

function updateWindow() {

    vidheight = videoPlayer.offsetWidth;
    background.style.top = "50%";
    background.style.marginTop = -(vidheight / (16/9)) / 2 + "px";
    background.style.height = (vidheight / (16 / 9)) + "px";
    progressBar.style.top = "50%";
    progressBar.style.marginTop = ((vidheight / (16 / 9)) / 2) + "px";

    pauseButton.style.top = "50%";
    pauseButton.style.marginTop = -(vidheight / (16 / 9)) / 2 + "px";
    pauseButton.style.height = (vidheight / (16 / 9)) + "px"

    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
}

// Base camera
camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.x = -8
camera.position.y = 3
camera.position.z = 16
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target = new THREE.Vector3(0, -1, 0);
controls.enableDamping = true
controls.enablePan = false;
controls.maxPolarAngle = 1.2;/*Math.PI / 1.90;*/
controls.minPolarAngle = 1.2;
controls.minDistance = 10;
controls.maxDistance = 30;


// Renderer
renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.gammaInput = true;
renderer.gammaOutput = true;
//renderer.toneMapping = THREE.ACESFilmicToneMapping;
//renderer.toneMappingExposure = 0.7;
//renderer.outputEncoding = THREE.sRGBEncoding;

//UPDATE OBJECTS
function updateHotspots() {
    for (var i = 0; i < hotspotGroup.children.length; i++) {
        hotspotGroup.children[i].lookAt(camera.position);
        if (i === 7) {
            if (drivingCar) {
                carpos = new THREE.Vector3(drivingCar.position.x / 100, (drivingCar.position.y / 100)-0.3, (drivingCar.position.z / 100)-0.9)
                hotspotGroup.children[i].position.copy(carpos)
            }
        }
    }
}

//INTERACTION  //////////////////////////////////////////////////////////////////////////
function cloudTransparant() {
    for (var i = 0; i < clouds.length; i++) {

        let cloud = scene.getObjectByName(clouds[i]);

        let distance = cloud.position.distanceTo(camera.position);
        let trans = inverseLerp(18, 20, distance);
        
        cloud.material.opacity = trans;
    }
}

function inverseLerp(x, y, value) {

    if (x !== y) {

        return (value - x) / (y - x);

    } else {

        return 0;

    }

}


function resetMaterials() {
    for (var i = 0; i < hotspotGroup.children.length; i++) {
        if (hotspotGroup.children[i].material) {
            hotspotGroup.children[i].material.opacity = hotspotGroup.children[i] == selectedHotspot ? 0.5 : 1.0
        }
    }
}

function hoverObject() {
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(hotspotGroup.children);
    for (let i = 0; i < intersects.length; i++)
    {
        intersects[i].object.material.opacity = 0.5;
    }
}


mouse = new THREE.Vector2();
raycaster = new THREE.Raycaster();


function onMouseMove(event)
{
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
}

function onMobileTouchStart(event) {
    event.preventDefault();
    mouse.x = (event.targetTouches[0].pageX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.targetTouches[0].pageY / window.innerHeight) * 2 + 1;
    onClick();
}

function onClick(event)
{
    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(hotspotGroup.children);
    if (intersects.length > 0 && selectedHotspot === null)
    {
            selectedHotspot = intersects[0].object;
          
            videoContainer.style.display = 'flex';
            for (var i = 0; i < hotspotGroup.children.length; i++) {
                if (selectedHotspot === hotspotGroup.children[i]) {

                    if (window.orientation == 90 || window.orientation == -90) {
                        videoContainer.style.width = "55%";
                    } else {
                        videoContainer.style.width = "70%";
                    }
                    
                    videoPlayer.src = 'assets/videos/' + videoContentSource[i];
                    playButton.style.background = 'url(' + playImages[i] + ')';
                    playButton.style.backgroundSize = "100%";

                    var ori = window.orientation;
                    if (ori != null) {
                        playButton.style.margin = "-30px 0 0 -70px"
                        playButton.style.height = "60px"
                        playButton.style.width = "140px"

                        progressBar.style.height = '15px';
                    }

                    progressBar.style.display = 'none';
                    progressBar.innerHTML = 0 + '% played';
                    progressBar.value = 0;

                    vidheight = videoPlayer.offsetWidth;
                    console.log(vidheight);
                    background.style.top = "50%";
                    background.style.marginTop = -(vidheight / (16 / 9)) / 2 + "px";
                    background.style.height = (vidheight / (16 / 9)) + "px"

                    pauseButton.style.top = "50%";
                    pauseButton.style.marginTop = -(vidheight / (16 / 9)) / 2 + "px";
                    pauseButton.style.height = (vidheight / (16 / 9)) + "px"
                }
        }

            videoPlayer.play();
            playButton.style.display = 'block';
            pauseButton.style.display = 'none';
            videoPlayer.pause();
            isPaused = true;
    }
}

window.addEventListener('resize', updateWindow, false);
window.addEventListener('mousemove', onMouseMove, false);
window.addEventListener('touchstart', onMobileTouchStart, false);
window.addEventListener('click', onClick);

window.addEventListener("orientationchange", function () {
    if (window.orientation == 90 || window.orientation == -90) {
        location.reload();
    } else {
        location.reload();
    }
});


// UPDATE ///////////////////////////////////////////////////////////////////////////////////

const clock = new THREE.Clock()

const tick = () => {

    const elapsedTime = clock.getElapsedTime();

    // Update objects
    
    //sphere.rotation.y = .5 * elapsedTime


    var delta = (Date.now() - lastframe) / 2000

    if (mixer) {
        if (!selectedHotspot) {
            mixer.update(delta);
        }
    }

    // Update Orbital Controls
    controls.update();

    //update hotspots
    updateHotspots();
    

    //interaction
    resetMaterials();
    hoverObject();

    cloudTransparant();

    // Render
    renderer.render(scene, camera);

    // Call tick again on the next frame
    window.requestAnimationFrame(tick);

    lastframe = Date.now();
}

tick()
